module.exports = __webpack_public_path__ + "static/media/raining_new.1543b81b.gif";